import type { RouteRecordRaw } from 'vue-router'
import {
  guardActivities,
  guardClients,
  guardContacts,
  guardSalesFunnelAccess,
  guardStats,
  guardWorkflows,
} from '../navigationsGuards/guardSalesFunnel'

const MODULE_NAME = 'SALESFUNNEL'
const MODULE_ID = 8

const saleRoutes: Array<RouteRecordRaw> = [
  {
    path: '/sales',
    meta: {
      requiresAuth: true,
    },
    beforeEnter: [guardSalesFunnelAccess],
    children: [
      // Static segments MUST be declared before :clientId
      {
        path: 'clients',
        name: 'ClientsList',
        component: () => import('@/views/salesFunnel/client/ClientsList.vue'),
        meta: {
          requiresAuth: true,
        },
        beforeEnter: [guardClients],
      },
      {
        path: 'funnel',
        name: 'SalesFunnel',
        component: () => import('@/views/salesFunnel/SalesFunnel.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'stats',
        name: 'Stats',
        component: () => import('@/views/salesFunnel/Stats.vue'),
        meta: {
          requiresAuth: true,
        },
        beforeEnter: [guardStats],
      },
      {
        path: 'contacts',
        name: 'ContactsList',
        component: () => import('@/views/salesFunnel/contacts/ContactsList.vue'),
        meta: {
          requiresAuth: true,
        },
        beforeEnter: [guardContacts],
      },
      {
        path: 'activities',
        name: 'ActivitiesList',
        component: () => import('@/views/salesFunnel/activities/ActivitiesList.vue'),
        meta: {
          requiresAuth: true,
        },
        beforeEnter: [guardActivities],
      },
      {
        path: 'deals/:engagementId',
        name: 'DealWorkspace',
        component: () => import('@/views/salesFunnel/deals/DealWorkspace.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'workflows',
        name: 'WorkflowsList',
        component: () => import('@/views/salesFunnel/workflows/WorkflowsList.vue'),
        meta: {
          requiresAuth: true,
        },
        beforeEnter: [guardWorkflows],
      },
      {
        path: ':clientId',
        name: 'ClientDetails',
        component: () => import('@/views/salesFunnel/client/ClientDetails.vue'),
        meta: {
          requiresAuth: true,
        },
        beforeEnter: [],
      },
    ],
  },
]

export default saleRoutes.map(route => ({ ...route, meta: { ...route.meta, moduleName: MODULE_NAME, moduleId: MODULE_ID } }))
